import React from 'react';

import IssueStatusesSelect from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/IssueStatusesSelect';
import Field from 'src/views/components/Form/Field';

export const name = 'jira_change_status';
export const label = 'Change Jira issue status to';
export const type = 'issue_create,issue_update';

export const AdditionalParams = ({ name, values = {}, touched = false, errors = null, onChange, onBlur }) => {
  return (
    <Field label="Select Jira issue status">
      <IssueStatusesSelect
        isClearable
        name={`${name}.jira_change_status`}
        value={values.jira_change_status}
        onChange={onChange}
        onBlur={onBlur}
      />
    </Field>
  );
};
